import {
  createFileRoute,
  useNavigate,
  useRouteContext,
} from '@tanstack/react-router';
import { parseAsString, useQueryState } from 'nuqs';
import { useState } from 'react';

import { Route as LoginRoute } from '@/app/routes/login';
import { AuthButton } from '@/features/auth/components/auth-button';
import { AuthForm } from '@/features/auth/components/auth-form';
import { AuthInput } from '@/features/auth/components/auth-input';
import { AuthLayout } from '@/features/auth/components/auth-layout';

export function UpdatePasswordPage() {
  const { auth } = useRouteContext({ from: '/_authenticated' });

  const { updatePassword } = auth;

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const navigate = useNavigate();
  const [token] = useQueryState('token', parseAsString.withDefault(''));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    await updatePassword.mutateAsync(newPassword);
    await navigate({
      to: LoginRoute.to,
    });
  };

  if (!token) {
    return (
      <AuthLayout>
        <div className="space-y-6">
          <div className="text-center space-y-2">
            <h2 className="text-2xl font-semibold">Invalid Request</h2>
            <p className="text-sm text-gray-600">
              This password reset link is invalid or has expired.
            </p>
          </div>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <AuthForm onSubmit={handleSubmit} title="Update Password" description="">
        <AuthInput
          id="password"
          type="password"
          label="New Password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          autoComplete="new-password"
        />
        <AuthInput
          id="confirm-password"
          type="password"
          label="Confirm New Password"
          placeholder="Confirm New Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          autoComplete="new-password"
        />
        <AuthButton type="submit" disabled={updatePassword.isPending}>
          {updatePassword.isPending ? 'Updating...' : 'Update Password'}
        </AuthButton>
      </AuthForm>
    </AuthLayout>
  );
}

export const Route = createFileRoute('/update-password')({
  component: UpdatePasswordPage,
});
